import React from 'react';
import {ManifestInfo} from "mirador/dist/es/src/components/ManifestInfo";

/**
 * RemoveDoubleManifestTitlePlugin
 * Removes the double title in the info section
 */
const RemoveDoubleManifestTitlePlugin = (props) => {
    const modifiedProps = {...props, manifestLabel: null};
    return <ManifestInfo {...modifiedProps} />;
};


const removeDoubleManifestTitlePlugin = {
    target: 'ManifestInfo',
    mode: 'wrap',
    component: RemoveDoubleManifestTitlePlugin,
};


export {removeDoubleManifestTitlePlugin};
